export const extractS3Key = (xmlText: string, fallback: string): string => {
  const key = new DOMParser().parseFromString(xmlText, 'application/xml').querySelector('Key')?.textContent
  return key || fallback
}
